import React from 'react';
import SignIn from '../../@jumbo/components/Common/authComponents/SignIn';
import { useDocumentTitle } from '@/hooks/use-document-title';

const Login = () => {
  useDocumentTitle('Login');

  return <SignIn variant='standard' wrapperVariant='bgColor' />;
};

export default Login;
